"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _styles = require("../styles");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Blocked = function Blocked(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? '' : _ref$animation;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/React.createElement(_styles.Svg, {
    className: "".concat(className, " ").concat(animation),
    width: size,
    height: size,
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6 5.676c-.008-.008-.012-.02-.02-.032-.008-.008-.016-.008-.024-.016a6.926 6.926 0 0 0-4.964-2.088c-3.84 0-6.964 3.12-6.964 6.96 0 1.824.708 3.476 1.86 4.72.012.012.012.028.024.04.008.008.02.012.028.02a6.932 6.932 0 0 0 5.048 2.18c3.84 0 6.964-3.124 6.964-6.96A6.927 6.927 0 0 0 15.6 5.676Zm-5.008-.864c1.364 0 2.6.5 3.58 1.304L6.04 13.88a5.643 5.643 0 0 1-1.136-3.38 5.695 5.695 0 0 1 5.688-5.688Zm0 11.376c-1.408 0-2.684-.536-3.68-1.384l8.148-7.78c.752.964 1.22 2.16 1.22 3.476a5.695 5.695 0 0 1-5.688 5.688Z",
    fill: color
  }));
};
var _default = exports["default"] = Blocked;